import axios from 'axios';

const baseURL = 'https://supply.albaughparaguay.com.py/ss';

export const login = (user, password) => {
    return axios.post(`${baseURL}/api/Aprovadores/login`, {
        passwordSAP: password,
        email: user
    })
};

export const list = (userId) => {
    return axios.get(`${baseURL}/api/Aprovadores/${userId}`)
};

export const save = (data) => {
    console.log(data)
    return axios.post(`${baseURL}/api/Aprovadores/autorizacao`, data)
};

export const getDocEntry = (userId, docEntry) => {
    return axios.get(`${baseURL}/api/aprovadores/${userId}/${docEntry}`)
};
